module.exports = __webpack_public_path__ + "img/winerack41.07090393.jpg";